import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CiiPredictiveData {
  vessel: {
    imo_number: string;
    vessel_name: string;
    dwt: number;
    ship_type: string;
    [key: string]: any;
  };
  period: {
    start_date: string;
    end_date: string;
    months: number;
    reporting_year: number;
    days_elapsed: number;
    days_remaining: number;
    total_days_year: number;
    projection_ratio: number;
    is_annual_projection: boolean;
    source: string;
    [key: string]: any;
  };
  current_status: {
    attained_cii: number;
    required_cii: number;
    current_band: string;
    band_max_threshold: number;
    buffer_percentage: number;
    target_cii_ceiling: number;
    band_boundaries: {
      A_upper: number;
      B_upper: number;
      C_upper: number;
      D_upper: number;
      [key: string]: any;
    };
    [key: string]: any;
  };
  baseline_stats: {
    distance_ytd: number;
    fuel_ytd: number;
    net_distance_nm: number;
    excluded_distance_nm: number;
    total_fuel_mt: number;
    net_fuel_mt: number;
    excluded_fuel_mt: number;
    cargo_ops_fuel_mt: number;
    total_co2_mt: number;
    [key: string]: any;
  };
  scenario_fixed_distance: {
    distance_nm: number;
    projected_remaining_distance_nm: number;
    annual_projected_distance_nm: number;
    max_annual_allowed_fuel_mt: number;
    max_allowed_net_fuel_mt: number;
    fuel_allowance_margin_mt: number;
    has_allowance: boolean;
    summary: string;
    [key: string]: any;
  };
  scenario_fixed_fuel: {
    net_fuel_mt: number;
    projected_remaining_fuel_mt: number;
    annual_projected_fuel_mt: number;
    min_required_distance_nm: number;
    required_annual_distance_nm: number;
    distance_buffer_nm: number;
    has_buffer: boolean;
    summary: string;
    [key: string]: any;
  };
  [key: string]: any;
}

@Component({
  selector: 'app-cii-predictive-allowance-modal',
  templateUrl: './cii-predictive-allowance-modal.component.html',
  styleUrls: ['./cii-predictive-allowance-modal.component.scss']
})
export class CiiPredictiveAllowanceModalComponent implements OnInit {
  activeTab: 'distance' | 'fuel' = 'distance';

  constructor(
    public dialogRef: MatDialogRef<CiiPredictiveAllowanceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }

  getBandColor(band?: string): string {
    switch (band) {
      case 'A': return '#10b981';
      case 'B': return '#06b6d4';
      case 'C': return '#3b82f6';
      case 'D': return '#f59e0b';
      case 'E': return '#ef4444';
      default: return '#6b7280';
    }
  }

    getDailyAllowanceFormatted(): string {
    if (!this.data || !this.data.scenario_fixed_distance || !this.data.period) return '';
    const remaining = this.data.scenario_fixed_distance.fuel_allowance_margin_mt || 0;
    const days = this.data.period.days_remaining || 0;
    if (days <= 0) return '';
    const daily = remaining / days;
    return 'Max ' + daily.toFixed(1) + ' MT/day';
  }

  getFuelProgressWidth(): number {
    if (!this.data || !this.data.scenario_fixed_distance || !this.data.baseline_stats) return 0;
    const actual = this.data.baseline_stats.net_fuel_mt || 0;
    const max = this.data.scenario_fixed_distance.max_allowed_net_fuel_mt || 0;
    if (max <= 0) return 100;
    return Math.min(100, Math.round((actual / max) * 100));
  }

  getDistProgressWidth(): number {
    if (!this.data || !this.data.scenario_fixed_fuel || !this.data.baseline_stats) return 0;
    const actual = this.data.baseline_stats.net_distance_nm || 0;
    const min = this.data.scenario_fixed_fuel.min_required_distance_nm || 0;
    if (min <= 0) return 100;
    return Math.min(100, Math.round((actual / min) * 100));
  }
}
